import { render, staticRenderFns } from "./MedicalRecipe.vue?vue&type=template&id=2a894163&scoped=true"
import script from "./MedicalRecipe.vue?vue&type=script&lang=js"
export * from "./MedicalRecipe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a894163",
  null
  
)

export default component.exports